<div class="d-flex flex-column pt-5 Enterprise_wrapper">
  <div class="flex-grow-1 m-auto pb-5">
    <h2 class="text-center">Enterprise</h2>
    <p class="text-center">
      Our Enterprise version just may be the perfect fit.
      <span class="color-orange"
        >We easily integrate with your current infrastructure</span
      >
      while solving <br />
      one of the biggest problems in sales-prospecting!
    </p>
  </div>
  <div class="flex-grow-1 m-auto Enterprise_wrapper_selllist">
    <div class="container d-flex flex-row">
      <div class="flex-grow-1 d-flex w-100 justify-content-center flex-column">
        <h2 class=""><span>Enterprise Highlights</span></h2>
        <ul>
          <li>Custom Reporting</li>
          <li>Unlimited Contacts</li>
          <li>Enhanced Content Creation</li>
          <li>Integration with critical applications like CRM</li>
          <li>API</li>
          <li>Custom Training</li>
          <li>Virtual Sales Manager</li>
        </ul>
        <app-button
          [route]="'/contact_us'"
          [color]="'orange'"
          [text]="'Contact us'"></app-button>
      </div>
      <div class="flex-grow-1 d-flex w-100 justify-content-center">
        <img
          class="ms-5"
          src="assets/images/retail/enterprise-icon.png"
          alt="" />
      </div>
    </div>
  </div>
</div>
